import * as z from "zod";

const GALE_MIN_PERCENTAGE_FEE_BPS = 290;

// Presence of `lmnFeeCents` selects LMN pricing over standard processing.
export const galePricingInputSchema = z.object({
  percentageFeeBps: z.number().int().min(GALE_MIN_PERCENTAGE_FEE_BPS),
  flatFeeCents: z.number().int().nonnegative(),
  lmnFeeCents: z.number().int().nonnegative().optional(),
});

export const galePricingOutputSchema = z.object({
  percentageFeeBps: z.number(),
  flatFeeCents: z.number(),
  lmnFeeCents: z.number().nullable(),
});

export type GalePricingOutput = z.infer<typeof galePricingOutputSchema>;
